<template>
  <div>
    <h1 class="page-header">{{ $t('vehicleProfile.vehicleProfile') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <fieldset>
            <legend>{{ $t('vehicleProfile.actionForm') }}</legend>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label required">{{
                    $t('vehicleProfile.car_number')
                  }}</label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model="model.car_number"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('car_number') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('car_number')"
                    >
                      {{ errors.first('car_number') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label required">{{
                    $t('vehicleProfile.plate_no')
                  }}</label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model="model.plate_no"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('plate_no') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('plate_no')">
                      {{ errors.first('plate_no') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label required">{{
                    $t('vehicleProfile.number_seat')
                  }}</label>
                  <div class="col-md-8">
                    <input
                      type="number"
                      v-model.number="model.seat_no"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('seat_no') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('seat_no')">
                      {{ errors.first('seat_no') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label required">{{
                    $t('vehicleProfile.max_capacity')
                  }}</label>
                  <div class="col-md-8">
                    <input
                      type="number"
                      v-model.number="model.max_student"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('max_student') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('max_student')"
                    >
                      {{ errors.first('max_student') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label required">{{
                    $t('vehicleProfile.purchasing_date')
                  }}</label>
                  <div class="col-md-8">
                    <ts-date-picker-input
                      v-model="model.date_purchasing"
                    ></ts-date-picker-input>
                    <div class="invalid" v-if="errors.has('date_purchasing')">
                      {{ errors.first('date_purchasing') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label required">{{
                    $t('vehicleProfile.register_date')
                  }}</label>
                  <div class="col-md-8">
                    <ts-date-picker-input
                      v-model="model.register_date"
                    ></ts-date-picker-input>
                    <div class="invalid" v-if="errors.has('register_date')">
                      {{ errors.first('register_date') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label">Brand</label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model="model.model"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('model') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('model')">
                      {{ errors.first('model') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label">{{
                    $t('vehicleProfile.engine_no')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      type="text"
                      v-model="model.engine_no"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('engine_no') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('engine_no')"
                    >
                      {{ errors.first('engine_no') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label">{{
                    $t('vehicleProfile.frame_no')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      type="text"
                      v-model="model.frame_no"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('frame_no') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('frame_no')">
                      {{ errors.first('frame_no') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label">{{
                    $t('vehicleProfile.color')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      type="text"
                      v-model="model.color"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('color') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('color')">
                      {{ errors.first('color') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label">{{
                    $t('vehicleProfile.power_cc')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      type="text"
                      v-model="model.powercc"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('powercc') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('powercc')">
                      {{ errors.first('powercc') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label">{{
                    $t('vehicleProfile.year_of_product')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      type="text"
                      v-model="model.year_of_product"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('year_of_product') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('year_of_product')"
                    >
                      {{ errors.first('year_of_product') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label">{{
                    $t('vehicleProfile.price')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      type="number"
                      step="any"
                      v-model.number="model.price"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('price') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('price')">
                      {{ errors.first('price') }}
                    </div>
                  </div>
                </div>
                <!-- <div class="row form-group m-b-15">
                  <label class="col-md-3 col-form-label">Assistant</label>
                  <div class="col-md-9">
                    <ts-search-select
                      v-model.number="model.vehicle_assistant_staff_id"
                      :options="employees"
                    ></ts-search-select>
                    <div
                      class="invalid"
                      v-if="errors.has('vehicle_assistant_staff_id')"
                    >{{ errors.first('vehicle_assistant_staff_id') }}</div>
                  </div>
                </div> -->
              </div>
            </div>
          </fieldset>
          <div class="row mt-3">
            <div class="col-sm-12 text-right">
              <ts-button
                class="btn-default"
                @click.prevent="$router.push({ name: 'vehicle-profile' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                outline
                color="primary"
                class="ml-2"
                :waiting="waiting_save_new"
                @click.prevent="saveAddNew"
                >{{ $t('save_add_new') }}</ts-button
              >
              <ts-button
                color="primary"
                class="ml-2"
                @click.prevent="store"
                :waiting="waiting_save"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment, { months } from 'moment'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'vehicleProfile-create',
  data () {
    return {
      errors: new Errors(),
      waiting_save: false,
      waiting_save_new: false,
      model: {
        car_number: '',
        plate_no: '',
        seat_no: '',
        model: '',
        max_student: '',
        date_purchasing: moment().format('DD-MM-YYYY'),
        register_date: moment().format('DD-MM-YYYY'),
        engine_no: '',
        color: '',
        powercc: '',
        year_of_product: '',
        vehicle_assistant_staff_id: ''
      }
    }
  },
  computed: {
    employees () {
      return this.$store.state.vehicleProfile.employees.map(el => ({
        value: el.staff_id,
        text: el.name_en
      }))
    }
  },
  created () {},
  methods: {
    store () {
      this.errors = new Errors()
      this.waiting_save = true
      this.$store
        .dispatch('vehicleProfile/store', this.model)
        .then(response => {
          this.waiting_save = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'vehicleProfile' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting_save = false
        })
    },
    saveAddNew () {
      this.errors = new Errors()
      this.waiting_save_new = true
      this.$store
        .dispatch('vehicleProfile/store', this.model)
        .then(response => {
          this.waiting_save_new = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting_save_new = false
        })
    },
    clearInput () {
      this.model = {
        car_number: '',
        plate_no: '',
        seat_no: '',
        model: '',
        max_student: '',
        date_purchasing: moment().format('DD-MM-YYYY'),
        register_date: moment().format('DD-MM-YYYY'),
        engine_no: '',
        color: '',
        powercc: '',
        year_of_product: '',
        vehicle_assistant_staff_id: ''
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('vehicleProfile/RESET_STATE')
    }
    next()
  }
}
</script>
